module.exports = __webpack_public_path__ + "img/14b54f7.jpg";